/** When set to `agritour`, only AgriTour public routes are reachable. */
export type PublicSlice = 'agritour' | undefined;

export function getPublicSlice(): PublicSlice {
  const raw = (import.meta.env.VITE_PUBLIC_SLICE as string | undefined)?.trim();
  return raw === 'agritour' ? 'agritour' : undefined;
}

export function isAgritourPublicSlice(): boolean {
  return getPublicSlice() === 'agritour';
}

/** Routes allowed when VITE_PUBLIC_SLICE=agritour (questionnaire only — map is embed-gated in prod). */
export const AGRITOUR_PUBLIC_PATHS = new Set([
  '/questionnaire',
  '/agritour',
  '/agritour/entrepreneurs-map',
]);

export function isPathAllowedInPublicSlice(pathname: string): boolean {
  if (AGRITOUR_PUBLIC_PATHS.has(pathname)) {
    return true;
  }
  return false;
}
